import { useContext, useEffect, useState } from "react"
import { singletonHook } from "react-singleton-hook"
import { AuthContext } from "react-builder"
import { DomainConfigContext } from "react-builder"

export interface IQResult {
    date: "29/01/2020"
    num: 1
    score: "545"
    time: "00:00:26.461"
}

export interface TopPlayer {
    num: 1,
    user: ""
    score: ""
}

export interface GaugeInfo {
    avgSuccess: 23.972912
    categoryId: 1
}

export interface IQQuestion {
    "answers":
    {
        "aImg": "/questions/47-05.png/47-04.png",
        "text": null,
        "answerNum": 1,
        "isCorrect": null,
        "answerId": 5705
    }[],
    "qImg": "/questions/47-05.png/47-05.png",
    "id": 1427,
    "text": "what continues the above sequence?",
    "title": "undefined"
}

export interface IQBellCurveResponse {
    result: number
}

export interface HeatMapData { "userAvg": 0.0, "mapCountryList": { "countryCode": "AU", "countryAvg": 536.0 }[] }

export interface IQApi {
    getLastResults: () => Promise<IQResult[]>
    getPersonalBest: () => Promise<IQResult[]>
    getLeaderboardData: () => Promise<TopPlayer[]>
    getGaugesInfo: () => Promise<GaugeInfo[]>
    getHeatmapData: () => Promise<HeatMapData>
    startGame: () => Promise<IQQuestion>
    answerQuestion: (a: IQAnswer) => Promise<IQQuestion>
    getBellCurveResult: () => Promise<IQBellCurveResponse>
    getQuestionsPerCategory: () => Promise<number>
    endGame: () => Promise<IQEndGameResponse>
    startCategory: () => Promise<any>
    endCategory: () => Promise<any>
}

export interface IQAnswer {
    answerId: number
    answerNumber: number
    questionId: number
    questionNum: number
}

export interface IQEndGameResponse { "hours": 0, "minutes": 0, "seconds": 19, "millis": 914, "firstCategoryScore": 2, "secondCategoryScore": 0, "thirdCategoryScore": 1, "fourthCategoryScore": 2, "rank": 1, "total": 1 }



export const useIQGame = singletonHook<IQApi | undefined>(undefined, function () {

    let config = useContext(DomainConfigContext);
    const auth = useContext(AuthContext);


    const [gameApi, setGameApi] = useState<IQApi>({

        getLastResults: () => {
            return fetch(`${config?.apiEndpoint}rest/game/getLastResults`, {
                "headers": {
                    "content-type": "application/json",
                },
                "body": JSON.stringify({ userId: auth?.getSession()?.userIden }),
                "method": "POST",
            }).then((res) => res.json())
        },
        getPersonalBest: () => {
            return fetch(`${config?.apiEndpoint}rest/game/getPersonalBest`, {
                "headers": {
                    "content-type": "application/json",
                },
                "body": JSON.stringify({ userId: auth?.getSession()?.userIden }),
                "method": "POST",
            }).then((res) => res.json());
        },
        getLeaderboardData: () => {
            return fetch(`${config?.apiEndpoint}rest/game/getLeaderboardData`, {
                "headers": {
                    "content-type": "application/json",
                },
                "method": "GET",
            }).then((res) => res.json());
        },
        getQuestionsPerCategory: () => {
            return fetch(`${config?.apiEndpoint}rest/game/questionsPerCategory`, {
                "headers": {
                    "content-type": "application/json",
                },
                "method": "GET",
            }).then((res) => res.text())
                .then((r) => parseInt((r)));
        },
        getGaugesInfo: () => {
            return fetch(`${config?.apiEndpoint}rest/game/getGaugesInfo`, {
                "headers": {
                    "content-type": "application/json",
                },
                "body": JSON.stringify({ userId: auth?.getSession()?.userIden }),
                "method": "POST",
            }).then((res) => res.json());
        },
        getHeatmapData: () => {
            return fetch(`${config?.apiEndpoint}rest/game/getHeatmapData`, {
                "headers": {
                    "content-type": "application/json",
                },
                "body": JSON.stringify({ userId: auth?.getSession()?.userIden }),
                "method": "POST",
            }).then((res) => res.json());
        },

        startGame: () => {
            var myHeaders = new Headers();

            myHeaders.append("content-type", "application/json");


            var raw = JSON.stringify({
                "userId": auth?.getSession()?.user?.userId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            };

            return fetch(`${config?.apiEndpoint}rest/game/startGame`, requestOptions)
                .then(response => response.json())
        },
        getBellCurveResult: () => {
            var myHeaders = new Headers();

            myHeaders.append("content-type", "application/json");


            var raw = JSON.stringify({
                "userId": auth?.getSession()?.user?.userId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            };

            return fetch(`${config?.apiEndpoint}rest/game/getBellCurveResult`, requestOptions)
                .then(response => response.json()).catch()
        },
        endGame: () => {
            var myHeaders = new Headers();

            myHeaders.append("content-type", "application/json");


            var raw = JSON.stringify({
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            };

            return fetch(`${config?.apiEndpoint}rest/game/endGame`, requestOptions)
                .then(response => response.json()).catch()
        },

        answerQuestion: (answer: IQAnswer) => {
            var myHeaders = new Headers();
            myHeaders.append("content-type", "application/json");

            var raw = JSON.stringify(answer);

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            };

            return fetch(`${config?.apiEndpoint}rest/game/answerQuestion`, requestOptions)
                .then(response => response.json().catch((e) => ({})));
        },
        startCategory: () => {
            var myHeaders = new Headers();

            myHeaders.append("content-type", "application/json");


            var raw = JSON.stringify({
                "userId": auth?.getSession()?.user?.userId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            };

            return fetch(`${config?.apiEndpoint}rest/game/startCategory`, requestOptions)
        },
        endCategory: () => {
            var myHeaders = new Headers();

            myHeaders.append("content-type", "application/json");


            var raw = JSON.stringify({
                "userId": auth?.getSession()?.user?.userId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            };

            return fetch(`${config?.apiEndpoint}rest/game/endCategory`, requestOptions)

        },
    });

    return gameApi;
});
